import { toLocaleString3 } from '../strings'

export const overviewGeneralStockParser = (data: any[]): any[] => {
  const rows: any[] = []
  for (const entity of data) {
    rows.push({
      status: entity.status,
      cd: toLocaleString3(entity.centroDistribuicao),
      loja: toLocaleString3(entity.loja),
      total: toLocaleString3(entity.total)
    })
  }
  return rows
}

export const overviewGeneralStockParserFooter = (data: any[]): any[] => {
  const rows: any[] = []
  let cd = 0
  let loja = 0
  let total = 0
  data.forEach(obj => {
    return (cd += obj.centroDistribuicao)
  })
  data.forEach(obj => {
    return (loja += obj.loja)
  })
  data.forEach(obj => {
    return (total += obj.total)
  })
  rows.push({
    status: 'TOTAL',
    cd: toLocaleString3(cd),
    loja: toLocaleString3(loja),
    total: toLocaleString3(total)
  })
  return rows
}

export const overviewGeneralStockParserWithFooter = (data: any[]): any[] => {
  const rows: any[] = []
  for (const entity of data) {
    rows.push({
      status: entity.status,
      cd: toLocaleString3(entity.centroDistribuicao),
      loja: toLocaleString3(entity.loja),
      total: toLocaleString3(entity.total)
    })
  }

  const footerRoews = overviewGeneralStockParserFooter(data)
  rows.push(footerRoews[0])
  return rows
}
